import {
  RefineThemedLayoutV2SiderProps,
  ThemedSiderV2,
} from "@refinedev/mui";
import Box from "@mui/material/Box";

// Removes logout button from sidebar — the account menu itself lives in the
// header. The collapse/expand toggle also lives in the header (far left,
// see Header.tsx), not here — ThemedSiderV2's own built-in one is hidden via
// CSS since it only ever collapses (no way back).
export const Sider = (props: RefineThemedLayoutV2SiderProps) => {
  return (
    <ThemedSiderV2
      {...props}
      render={({ items, collapsed }) => (
        <Box className={collapsed ? "sider-collapsed" : undefined}>{items}</Box>
      )}
    />
  );
};
